<app-navbar></app-navbar>
<router-outlet></router-outlet>
<button id="button-top" *ngIf="isShow" (click)="gotoTop()"><span class="material-icons material-icons-md-48">keyboard_arrow_up</span></button>
